import React, { useEffect } from 'react'
import NavbarTop from './../components/global/NavbarTop';
import AboutUsContent from '../components/AboutUs/AboutUsContent';
// import Footer from './../components/global/Footer';
// import NavbarBottom from './../components/global/NavbarBottom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectLanguage } from './../redux/language/selector';

const AboutUs = () => {
  const {t} = useTranslation()

  const language = useSelector(selectLanguage)

  useEffect(() => {
    document.title = t('about-us-page.about-us-page-title')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language])

  return (
    <>
        <NavbarTop/>
        <AboutUsContent/>
        {/* <Footer/> 
        <NavbarBottom/> */}
    </>
  )
}

export default AboutUs